// calculate the actual price amount based on currency exponent
const calcPrice = (amount, currency) => {
  if (typeof amount !== 'number' || !currency) return null;

  return amount * 10 ** (currency.exponent * -1);
};

export default calcPrice;
